// extracted by mini-css-extract-plugin
export var button = "_53-7";
export var buttonRow = "_53-6";
export var fadeIn = "_53-1";
export var gradient = "_53-0";
export var panel = "_53-2";
export var panelIn = "_53-3";
export var subtitle = "_53-5";
export var title = "_53-4";